import { HeatmapChart } from '@/common/dashboard/charts/HeatmapChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';


export const FinanceDashboardGrowthChart = ({
  startPeriod,
  endPeriod,
  periodicity,
  prodIds,
  channelIds,
  entity,
  changeType
}) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const { navigateTo } = useNavState();


  useEffect(() => {
    if (!prodIds?.length) return;
    if (!channelIds?.length) return;


    const ndc11ProdIds = prodIds.map((prod) => prod);
    const reqParam = { changeType, startPeriod, endPeriod, periodicity, ndc11ProdIds, channelIds, entity };

    rsrc
      .data('gtn', 'RESERVE_METRICS_DASHBOARD_DATA_PLUGIN', reqParam, entity)
      .then((rows) => setData(rows));
  }, [changeType, startPeriod, endPeriod, periodicity, prodIds, channelIds, entity]);

  if (!data) return null;

  const handleClick = (clickData) => {
    const code = clickData.category; // e.g. "2024Q4" or "2024M11"
    let PAID_PERIOD = [data.periodIdMap[clickData.category]];
    if (periodicity === 'QTR') {
      const periodCodes = expandQuarterToMonths(code); // ["2024M10", "2024M11", "2024M12"]

      PAID_PERIOD = periodCodes
        .map(c => data.periodIdMap[c])
        .filter(Boolean);
    }

    navigateTo('gtn/reserve', {
      mode: Mode.PERSPECTIVE,
      perspectiveState: {
        dimFilters: {
          CHANNEL: channelIds,
          PROD: prodIds,
          PAID_PERIOD: PAID_PERIOD,
        },
        dimToPeriodicities: {
          PAID_PERIOD: [periodicity],
          EARNED_PERIOD: ['QTR']
        }
      },
    });
  }

  // Helper: expand a quarterly code into its months
  function expandQuarterToMonths(periodCode) {
    const match = periodCode.match(/^(\d{4})Q([1-4])$/);
    if (!match) return [periodCode]; // Not a quarter → return as-is

    const year = match[1];
    const quarter = Number(match[2]);

    // Define month suffixes for each quarter
    const quarterMonths = {
      1: ['M01', 'M02', 'M03'],
      2: ['M04', 'M05', 'M06'],
      3: ['M07', 'M08', 'M09'],
      4: ['M10', 'M11', 'M12'],
    };

    // Build the monthly codes
    return quarterMonths[quarter].map(m => `${year}${m}`);
  }

  return (
    <HeatmapChart
      data={data}
      showValues={true}
      displayAsPercentage={true}
      // xLabel="Months"
      // yLabel="Channels"
      minColor="#ffcccc"   // light-to-dark red gradient for negatives
      maxColor="#66cc66"   // light-to-dark green gradient for positives
      onClick={handleClick}
    />
  );
};
